/**
 * useLeaveBalance — React Query hook szabadság egyenleg lekérdezéséhez
 */

import { useQuery } from '@tanstack/react-query';
import { getLeaveBalance, type LeaveBalance } from '../api/hr-api';

export function leaveBalanceQueryKey(employeeId: string, year: number) {
  return ['hr', 'leave', 'balance', employeeId, year] as const;
}

export function useLeaveBalance(employeeId: string | undefined, year: number) {
  return useQuery<LeaveBalance[]>({
    queryKey: employeeId
      ? leaveBalanceQueryKey(employeeId, year)
      : ['hr', 'leave', 'balance', 'none', year],
    queryFn: async () => {
      if (!employeeId) return [];
      const res = await getLeaveBalance(employeeId, year);
      return res.data;
    },
    enabled: Boolean(employeeId),
    staleTime: 60_000,
  });
}
